import Button from '@material-ui/core/Button';
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { BackButton } from '../component/BackButton';
import { HeaderArticle } from '../component/HeaderArticle'
import { MetaTags } from '../component/MetaTags';
import emailjs from 'emailjs-com'
import { useSnackbar } from 'notistack'

export const Contact = () => {
    const [form, setForm] = React.useState({
        nomRc:"",
        email:"",
        message:""
    })
    const { enqueueSnackbar } = useSnackbar()

    const handleSubmit = (event) => {
        event.preventDefault()
        let html = {... form}
        emailjs.send("service_x0ftk5s", "template_gnopbgm", html, "user_jk0izvV6dcrHJmEOU05Ax")
        .then((result) => {
            enqueueSnackbar("Votre Email a bien étais envoyer",{
                variant:"success"
            })
        }, (error) => {
            enqueueSnackbar("Opération échouée. Veuillez réessayer.",{
                variant:"error"
            })
        });
    }
    return (
        <>
        <MetaTags
            meta={
                {
                    title:"Yates Equipement - Contact", 
                    description:"Yates Equipement , spécialiste marocain des équipements de protection individuelle (E.P.I.) : Chaussures de sécurité, casque , lunettes, gants, vêtement de travail livraison partout au Maroc",
                    keywords:"Protection des pieds, protection des mains, protection de la tête, protection du corps, EPI, équipement de protection individuelle, Gilet, casque, chaussure de sécurité, réfléchissant, masque à gaz anti particules, ffp1, ffp2, ffp3, norme, certification, sécurité, chaussure, collaborateur, activité, client, Maroc, professionnel, chantier, industrie, métallurgie, construction, échafaudage, harnais, hauteur, longe, safety, anti dérapant, anti perforation, 200 kilos joule, pression, résistance, embout métallique, cuir, similicuir, S1P, S3SRC, S1, S3, S5, S2, S4, botte de protection, pvc, enduit, daim, tige hydrofuge, cuissard, jaune, orange, ars, irona, 7042, Prossa, Jackhammer, 3M, Exena, WSP, Singer, U power, ELG, Rockwell, alimentaire, tiger, sabot, Norme : EN ISO 20345 : 2011 S3 SRC, anti chocs, hydrocarbures, respirant, antistatique, manchette, soudage, casque de soudure, anti coupure, manutention, anti chaleur, maille, acier, mécanique, risque, anti acide, maitrise, nitrile, latex, Delta plus, cartouche, filtre, préfiltre, bague de maintien, 6200, Climax, double, anti bruit, visière, transparent, imperméable, veste et pantalon, blouse, gilet, serge, bande, abrasive, bavette, 3 plis, imanor, lunette, bouchons,  MSA, approche feu, JSP, 745, 755, casquette anti heurte, Gsilent, Silent, panoramique, jetable, fond de casque, molette, pliable, fixation nasale, cuir grainé, valve, KN95, bec, appareil de protection respiratoire, Filtering Facepiece Particles, toxique, coronavirus, bicolore, Rabat, Temara, Bouznika, Marrakech, Tanger, Fès, Louka, Combinaison, multipoches, Scotchlite, Tablier, anti froid, avec bandes, fluo, ensemble de pluie, parka, tunique, casaque, étui, cordon, polycarbonate, antibuée, anti rayure, silicone, 731, Néon, Creta, Sardegna, Bird, Faucon, Ascend, taille haute, taille basse, Brezza, XR89 Boulevard, Antigua, bridé, point noué, anti chute, Mousqueton, ceinture de maintien, ligne de vie, stop chute, dos d’âne, abrasif, pictogramme, signalétique, lumineux, panneaux de chantier, protège poignets, guêtre, distributeur de gel, solution hydro alcoolique, Tapis désinfectant, aérosols, couvre-casque, manchon, Casablanca",
                    url:window.location.href,
                    image:`http://localhost:3000/assets/logo/footer-logo.svg`,
                }
            } />
        <HeaderArticle categorie={"Contact"} />
        <BackButton />
        <div style={{marginBottom:"200px"}}>
            <Container>
                <Row className="justify-content-center row-contact">
                    <Col className="col-contact" xs={10} sm={5} md={4} lg={4}>
                        <div className="contact contact-map">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3311.0743942134986!2d-6.9199887498779145!3d33.91348483238338!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xda7133c245bddc7%3A0xb1b28da1ff293c86!2sYates%20Equipement%20-%20Chaussure%20de%20s%C3%A9curit%C3%A9%20-%20EPI!5e0!3m2!1sfr!2sma!4v1615213143426!5m2!1sfr!2sma" allowfullscreen="" loading="lazy" style={{width:"100%", border:0}}></iframe>
                        </div>
                    </Col>
                    <Col className="col-contact" xs={10} sm={5} md={4} lg={4    }>
                        <div className="contact contact-info">
                            <h3>Contact</h3>
                            <p>Si vous avez une question, utilisez les informations de contact si dessous : </p>
                            <div className="flexBox">
                                <div className="contact-icon">
                                    <img src={process.env.PUBLIC_URL+'/assets/icon/world.svg'} alt="adresse yates equipement" />
                                </div>
                                <div className="contact-right">
                                    <span>Adresse : Temara</span>
                                    <p>73 Avenue Ahmed AL Hansali, Magasin
                                    nᵒ1, Temara</p>
                                </div>
                            </div>
                            <div className="flexBox">
                                <div className="contact-icon">
                                    <img src={process.env.PUBLIC_URL+'/assets/icon/world.svg'} alt="adresse yates equipement" />
                                </div>
                                <div className="contact-right">
                                    <span>Adresse : Bouznika</span>
                                    <p>Résidence Ennour lotissement Ghita,Magasin n°9 Bouznika</p>
                                </div>
                            </div>
                            <div className="flexBox">
                                <div className="contact-icon">
                                    <img src={process.env.PUBLIC_URL+'/assets/icon/send2.svg'} alt="email" />
                                </div>
                                <div>
                                    <span>Email :</span>
                                    <p style={{width:"max-content"}}>contact@yates-equipement.com</p>
                                </div>
                            </div>
                            <div className="flexBox">
                                <div className="contact-icon">
                                    <img src={process.env.PUBLIC_URL+'/assets/icon/tel2.svg'} alt="contact" />
                                </div>
                                <div>
                                    <span>Téléphone :</span>
                                    <p style={{padding:"0 !important", margin:"0px"}}>+212 662 746 731</p>
                                    <p style={{padding:"0 !important", margin:"0px"}}>+212 698 991 795</p>
                                    <p>+212 537 413 765</p>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col className="col-contact" xs={10} sm={5} md={4} lg={4}>
                        <div className="contact contact-map">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3316.47941374201!2d-7.162044784792262!3d33.77411598068254!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xda7a764d69e3021%3A0x27f283cbc628fd25!2sYates%20Equipement%20-%20Chaussure%20de%20s%C3%A9curit%C3%A9%20-%20EPI!5e0!3m2!1sfr!2sma!4v1617449916668!5m2!1sfr!2sma" allowfullscreen="" loading="lazy" style={{width:"100%", border:0}}></iframe>
                        </div>
                    </Col>
                    <Col className="col-contact" xs={10} sm={12} md={12} lg={12}>
                        <div className="contact contact-formulaire">
                            <h3>Envoyer un message</h3>
                            <form onSubmit={handleSubmit}>
                            <input type="txt" placeholder="Nom / raison sociale..." value={form.nomRc} onChange={(e) => setForm({... form, nomRc:e.target.value})} />
                            <input type="email" placeholder="Adresse email..." value={form.email} onChange={(e) => setForm({... form, email:e.target.value})} />
                            <textarea type="txt" value={form.message} onChange={(e) => setForm({... form, message:e.target.value})}></textarea>
                            <Button type="submit" variant="contained">
                                Envoyer
                            </Button>
                            </form>
                        </div>
                    </Col>
                    
                </Row>
            </Container>
        </div>
        </>
    )
}
